import { Card, Descriptions, Tag } from "antd";
import { FileTextOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";

export const InfoAsistencia = ({ asistenciaID }) => {
  const { captura } = useSelector((state) => state.asistenciasReducer);

  const nombre = captura.nombreLlamada || captura.nombre || "";
  const apellido = captura.apellidoPaternoLlamada || captura.apellidoPaterno || "";

  return (
    <Card size="small">
      <div className="crear-servicios-v2__section-header">
        <div className="crear-servicios-v2__section-header-title">
          <FileTextOutlined />
          <span>Asistencia</span>
        </div>
      </div>
      <Descriptions column={{ xs: 1, sm: 3 }} size="small" bordered>
        <Descriptions.Item label="ID">
          <Tag color="blue">{asistenciaID}</Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Nombre">
          {`${nombre} ${apellido}`.trim()}
        </Descriptions.Item>
        <Descriptions.Item label="Teléfono">
          {captura.telefono}
        </Descriptions.Item>
        <Descriptions.Item label="Validador 1">
          {captura.validador1}
        </Descriptions.Item>
        <Descriptions.Item label="Validador 2">
          {captura.validador2}
        </Descriptions.Item>
        {captura.nombreAjustador && (
          <Descriptions.Item label="Ajustador">
            {captura.nombreAjustador}
          </Descriptions.Item>
        )}
        {captura.requiereDestino !== undefined && (
          <Descriptions.Item label="Requiere Destino">
            <Tag color={captura.requiereDestino ? "green" : "default"}>
              {captura.requiereDestino ? "Sí" : "No"}
            </Tag>
          </Descriptions.Item>
        )}
      </Descriptions>
    </Card>
  );
};
